export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAIL = 'USER_LIST_FAIL';

export const NAV_DATA_REQUEST = 'NAV_DATA_REQUEST';
export const NAV_DATA_SUCCESS = 'NAV_DATA_SUCCESS';
export const NAV_DATA_FAIL = 'NAV_DATA_FAIL';
